export default {
  FULL: 'FULL',
  PARTIAL: 'PARTIAL',
  CONSOLIDATED: 'CONSOLIDATED',
};
